import { ajax } from "../ajax";
import { ReqType as reqType } from "../config";
import { obj2formData } from "../../utils/objectUtils";

//保存码头账号API
export const saveApi = (data) => {
  return ajax("/sys/terminal/account/save", obj2formData(data), reqType.POST);
};

//码头列表API
export const listApi = async () => {
  return ajax("/sys/terminal/account/list");
};

//删除码头账号API
export const deleteApi = async (id) => {
  return ajax("/sys/terminal/account/delete", { id });
};
